import InfoModal from '../../../../ui/InfoModal'

const PlanReductionModal = ({ isOpen, onClose }) => (
  <InfoModal
    isOpen={isOpen}
    onClose={onClose}
    title="Reducción de plan"
    closeText="Entendido"
  >
    <p>
      Las reducciones de plan requieren la aprobación de nuestros administradores, ya que necesitan una revisión previa.
    </p>
    <p className="mt-2">
      Por favor envíanos un correo a{' '}
      <a href="mailto:contacto@tryluca.cl" className="text-blue-600 font-medium">
        contacto@tryluca.cl
      </a>{' '}
      indicando el cambio que deseas realizar.
    </p>
  </InfoModal>
)

export default PlanReductionModal
